import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-smile-icon',
  templateUrl: './general-smile.component.html'
})
export class GeneralSmileComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
